export default [
  {
    path: '/cases',
    name: 'cases',
    component: () => import('@/views/cases/Cases.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASES',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Auth',
    },
  },
  {
    path: '/cases/details/:id',
    name: 'case-details',
    component: () => import('@/views/cases/CaseDetails.vue'),
    meta: {
      action: 'read',
      resource: 'Auth',
    },
  },
]
